export class HttpOptionsHelper {
  public static getOptions() {
    return { withCredentials: true };
  }
}
